import React from 'react';
import Paper from '@mui/material/Paper';
import useDebugInformation from '../../hooks/useDebugInformation';
const name = "StepThreeTabPanel"

type TabPanelProps = {
    children: any
    value: any
    index: number
    parent: string
}

const TabPanel: React.FC<TabPanelProps> = ({ parent, children, value, index }) => {
    const debugName = `${parent}▷[${name}]`
    useDebugInformation(debugName, { children })
    return (
        value === index ? <Paper elevation={4} sx={(theme) => ({
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            marginLeft: "2px",
            marginRight: "2px",
        })} >{children}</Paper> : null
    );
}

export default React.memo(TabPanel)